import React, { useState } from 'react';
import { CalendarIcon, PercentIcon, InfoIcon, FileTextIcon } from 'lucide-react';
export function QuoteDetailsStep({
  initialData,
  onUpdate
}) {
  const [formData, setFormData] = useState({
    quoteTitle: initialData.quoteTitle || '',
    quoteDescription: initialData.quoteDescription || '',
    relatedPivot: initialData.relatedPivot || '',
    pivotSerialNumber: initialData.pivotSerialNumber || '',
    discount: initialData.discount || 0,
    urgency: initialData.urgency || 'normal',
    notes: initialData.notes || '',
    ...initialData
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    onUpdate({
      ...formData,
      [name]: value
    });
  };
  return <div className="space-y-6" data-id="element-5309" data-mp="36ql7fp1u5hli">
      {/* Header */}
      <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-5 rounded-t-xl shadow-sm" data-id="element-5310" data-mp="36rd3t239bjcu">
        <div className="flex items-center" data-id="element-5311" data-mp="3hg49egqpysnv">
          <div className="p-2 mr-3 bg-blue-100 dark:bg-blue-900/40 rounded-lg" data-id="element-5312" data-mp="3hh5kgl7qjf5l">
            <FileTextIcon size={20} className="text-blue-600 dark:text-blue-400" data-id="element-5313" data-mp="3ment0ahubsd2" />
          </div>
          <div data-id="element-5314" data-mp="3rdqtriqsfcf8">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-5315" data-mp="3rd8vkgkkeo4o">
              Quote Details
            </h2>
            <p className="text-gray-500 dark:text-gray-400 text-sm" data-id="element-5316" data-mp="15x33c7o1yc">
              Provide the basic information for this quote
            </p>
          </div>
        </div>
      </div>
      {/* Basic Information */}
      <div className="bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-5317" data-mp="92dqb6zveclk">
        <div className="flex items-center mb-4" data-id="element-5318" data-mp="iygqi7b5w15v">
          <FileTextIcon size={20} className="text-blue-600 dark:text-blue-400 mr-2" data-id="element-5319" data-mp="ix5s6n0hjlm5" />
          <h3 className="text-gray-900 dark:text-white font-medium" data-id="element-5320" data-mp="2frsccbfpe9qg">
            Basic Information
          </h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-5321" data-mp="2kq3oisth0wbu">
          <div data-id="element-5322" data-mp="2cq73oz5s7ro2">
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5323" data-mp="2cpnwacdrcloa">
              Quote Title
            </label>
            <input type="text" name="quoteTitle" value={formData.quoteTitle} onChange={handleChange} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="E.g. Replacement Parts for Valley Center Pivot" data-id="element-5324" data-mp="27sfbs55505jv" />
          </div>
          <div data-id="element-5325" data-mp="35e2z80jm7dj9">
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5326" data-mp="35ci3i7lkdojt">
              Urgency
            </label>
            <select name="urgency" value={formData.urgency} onChange={handleChange} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none" style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%236B7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center',
            backgroundSize: '20px'
          }} data-id="element-5327" data-mp="30gtbqqfsdby2">
              <option value="low" data-id="element-5328" data-mp="3f272sf5ndt70">Low Priority</option>
              <option value="normal" data-id="element-5329" data-mp="31aaiuye4uplp">Normal</option>
              <option value="high" data-id="element-5330" data-mp="31blluvzr7tbr">High Priority</option>
              <option value="critical" data-id="element-5331" data-mp="35b46dqnny2e2">Critical/Emergency</option>
            </select>
          </div>
        </div>
        <div className="mb-4" data-id="element-5332" data-mp="2rcw0uuck9sra">
          <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5333" data-mp="2rcmklyhbizys">
            Quote Description
          </label>
          <textarea name="quoteDescription" value={formData.quoteDescription} onChange={handleChange} rows={3} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Provide a brief description of what these spare parts are for" data-id="element-5334" data-mp="2iy5nt5iqy0h"></textarea>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5335" data-mp="3fz5iwtw03x09">
          <div data-id="element-5336" data-mp="3axpyn41nduix">
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5337" data-mp="3ax7vrokhci21">
              Related Pivot/Machine
            </label>
            <input type="text" name="relatedPivot" value={formData.relatedPivot} onChange={handleChange} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="E.g. Valley 8000 series" data-id="element-5338" data-mp="31y2yelknmurg" />
          </div>
          <div data-id="element-5339" data-mp="1coslfwlc72rh">
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5340" data-mp="1coafg88vha6d">
              Serial Number (if applicable)
            </label>
            <input type="text" name="pivotSerialNumber" value={formData.pivotSerialNumber} onChange={handleChange} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Enter machine serial number" data-id="element-5341" data-mp="1hiemeri51i7g" />
          </div>
        </div>
      </div>
      {/* Discount and Notes */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5342" data-mp="12ot8zolsqs9c">
        {/* Discount Section */}
        <div className="bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-5343" data-mp="2a6sk165becih">
          <div className="flex items-center mb-4" data-id="element-5344" data-mp="f1b2fzba83ee">
            <div className="p-2 mr-2 bg-blue-100 dark:bg-blue-900/40 rounded-lg" data-id="element-5345" data-mp="ezzxvxa0irm8">
              <PercentIcon size={20} className="text-blue-600 dark:text-blue-400" data-id="element-5346" data-mp="a1f0e5m5am1h" />
            </div>
            <h3 className="text-gray-900 dark:text-white font-medium" data-id="element-5347" data-mp="o16fk9oee8h2">
              Discount
            </h3>
          </div>
          <div data-id="element-5348" data-mp="j3xwm6vfe0er">
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5349" data-mp="j1btqkjhc92v">
              Discount Percentage (%)
            </label>
            <div className="flex items-center" data-id="element-5350" data-mp="3ni5x4rhxehhe">
              <input type="range" name="discount" min="0" max="50" step="1" value={formData.discount} onChange={handleChange} className="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-lg appearance-none cursor-pointer accent-blue-500" data-id="element-5351" data-mp="3nf9zl49zputh" />
              <span className="ml-3 text-gray-900 dark:text-white font-medium min-w-[3rem] text-right" data-id="element-5352" data-mp="38ryk4raotqo3">
                {formData.discount}%
              </span>
            </div>
            <div className="flex justify-between text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-5353" data-mp="1jbcv0z20qa9g">
              <span data-id="element-5354" data-mp="1o21m4d9sd582">0%</span>
              <span data-id="element-5355" data-mp="1o2bbbyn0b8cp">25%</span>
              <span data-id="element-5356" data-mp="1o3mf3yggcg3t">50%</span>
            </div>
          </div>
          <div className="mt-4 bg-gray-50 dark:bg-gray-750 rounded-lg p-4 border border-gray-200 dark:border-gray-700" data-id="element-5357" data-mp="1ab6hxea8fcat">
            <div className="flex items-start" data-id="element-5358" data-mp="1faj6q4knytg1">
              <InfoIcon size={18} className="text-blue-600 dark:text-blue-400 mr-2 mt-0.5" data-id="element-5359" data-mp="22zc66b0hvjfe" />
              <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-5360" data-mp="22xhl8wp83rbb">
                Discounts are applied to the subtotal before shipping and taxes.
                Maximum discount is limited to 50%.
              </p>
            </div>
          </div>
        </div>
        {/* Notes Section */}
        <div className="bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-5361" data-mp="1y227e4r7tvew">
          <div className="flex items-center mb-4" data-id="element-5362" data-mp="mksrttb7jniv">
            <div className="p-2 mr-2 bg-blue-100 dark:bg-blue-900/40 rounded-lg" data-id="element-5363" data-mp="mmn98xn9sxi7">
              <CalendarIcon size={20} className="text-blue-600 dark:text-blue-400" data-id="element-5364" data-mp="1e9eyr7npl2r6" />
            </div>
            <h3 className="text-gray-900 dark:text-white font-medium" data-id="element-5365" data-mp="198ra2smycy04">
              Additional Notes
            </h3>
          </div>
          <div data-id="element-5366" data-mp="14caljxbuchmi">
            <textarea name="notes" value={formData.notes} onChange={handleChange} rows={5} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Enter any additional notes, special requirements or instructions..." data-id="element-5367" data-mp="zbe9gwhc5p60"></textarea>
          </div>
        </div>
      </div>
    </div>;
}